import React from "react";

const footerLinks = [
  { label: "Support", href: "#" },
  { label: "Privacy Policy", href: "#" },
  { label: "Terms of Service", href: "#" },
];

const Footer = () => {
  return (
    <footer
      className="w-full py-4 px-6 flex flex-col md:flex-row justify-between items-center 
                 bg-white border-t border-slate-200 mt-12 gap-2"
    >
      {/* Left Section */}
      <p className="text-xs text-slate-500">
        © {new Date().getFullYear()} Smil-e. All rights reserved.
      </p>

      {/* Right Section */}
      <div className="flex gap-6">
        {footerLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="text-xs text-slate-500 hover:text-primary underline transition-colors"
          >
            {link.label}
          </a>
        ))}
      </div>
    </footer>
  );
};

export default React.memo(Footer);